import { Margin } from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import axios from "axios";

const CartPage = () => {
    const [plates, setPlates] = useState(2);
    const [paymentMethod, setPaymentMethod] = useState("");
    const [showPaymentSection, setShowPaymentSection] = useState(false);


    const [orderId, setOrderId] = useState(null);
    const [showPaymentData, setShowPaymentData] = useState(false);


    const userId = localStorage.getItem("userId");
    const cartId = localStorage.getItem("cartId");


    const [walletType, setWalletType] = useState(""); // "company" / "sel



    const [cartItems, setCartItems] = useState([
        { id: 1, category: "Main Course", type: "Veg", name: "Paneer Butter Masala", price: 200 },
        { id: 2, category: "Bread", type: "Veg", name: "Butter Naan", price: 50 },
        { id: 3, category: "Dessert", type: "Veg", name: "Gulab Jamun", price: 80 }
    ]);

    const [vegPlates, setVegPlates] = useState(2);
    const [nonVegPlates, setNonVegPlates] = useState(1);
    const [mixedPlates, setMixedPlates] = useState(1);


    const [paymentMode, setPaymentMode] = useState(""); // "partial" | "full"



    const handlePartialPayment = () => {
        setPaymentMode("partial");
        setShowPaymentSection(true);
        setPaymentMethod(""); // reset
    };

    const handleFullPayment = () => {
        setPaymentMode("full");
        setShowPaymentSection(true);
        setPaymentMethod(""); // reset
    };

    const priceVeg = 200;
    const priceNonVeg = 250;
    const priceMixed = 220;

    // ✅ Subtotals
    const totalVeg = vegPlates * priceVeg;
    const totalNonVeg = nonVegPlates * priceNonVeg;
    const totalMixed = mixedPlates * priceMixed;

    // ✅ Total before discount/tax
    const subTotal = totalVeg + totalNonVeg + totalMixed;

    // ✅ Charges
    const discount = subTotal * 0.1; // 10%
    const sgst = subTotal * 0.09;
    const cgst = subTotal * 0.09;
    const deliveryCharge = 50;

    // ✅ Grand Total
    const afterDiscount = subTotal - discount;
    const grandTotal = afterDiscount + sgst + cgst + deliveryCharge;

    const pricePerPlate = 200;

    const discountPercent = 10;
    const sgstPercent = 9;
    const cgstPercent = 9;

    const totalPrice = cartItems.reduce((sum, item) => sum + item.price, 0) * plates;

    const advancePayment = (grandTotal * 40) / 100;





    const platformCharge = 30;


    // Totals
    const vegTotal = vegPlates * priceVeg;
    const nonVegTotal = nonVegPlates * priceNonVeg;
    const mixedTotal = mixedPlates * priceMixed;



    const removeItem = (id) => {
        setCartItems(cartItems.filter(item => item.id !== id));
    };

    const handleBookNow = () => {
        setShowPaymentSection(true);
        // Scroll to payment section
        setTimeout(() => {
            const element = document.getElementById("payment-section");
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }, 100);
    };

    // Reset payment section when cart items change
    useEffect(() => {
        setShowPaymentSection(false);
        setPaymentMethod("");
    }, [cartItems, plates]);



    const handlePay = () => {
        if (paymentMethod === "online") {
            alert(`Online Payment Success for ${paymentMode === "partial" ? advancePayment : grandTotal}`);
        } else if (paymentMethod === "cash") {
            alert(`Cash Payment Done for ${paymentMode === "partial" ? advancePayment : grandTotal}`);
        } else if (paymentMethod === "wallet") {
            if (!walletType) {
                alert("Please select Wallet Type");
            } else {
                alert(
                    `${walletType === "company" ? "Company Credit" : "Self Credit"} Payment Done for ${paymentMode === "partial" ? advancePayment : grandTotal
                    }`
                );
            }
        }
    };


    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    // ✅ Checkout function
    const handleCheckoutClickS = async () => {
        if (!userId) {
            alert("User ID not found. Please log in again.");
            return;
        }

        if (paymentMethod === "Maamaas_Wallet" && !walletType) {
            alert("Please select a wallet type before creating the order.");
            return;
        }

        try {
            localStorage.removeItem("orderId"); // clear previous

            if (paymentMethod === "Online_Payment") {
                const isRazorpayLoaded = await loadRazorpayScript();
                if (!isRazorpayLoaded) {
                    alert("❌ Razorpay SDK failed to load.");
                    return;
                }

                const amountInPaise = Math.round(grandTotal * 100); // ✅ Razorpay expects paise

                // Basic Auth
                const username = "rzp_live_RU5whSMu9rPV7s";
                const password = "FjLrs51Gf8Yq5OWT22CqamGF";
                const basicAuth = btoa(`${username}:${password}`);

                // ✅ Step 1: Create Razorpay Order in backend
                const orderResponse = await fetch(
                    " https://backend.maamaas.com/food/api/payments/create-order/user",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Basic ${basicAuth}`,
                        },
                        body: JSON.stringify({
                            amount: amountInPaise,
                            currency: "INR",
                            receipt: `order_${Date.now()}`,
                            notes: {
                                customer_name: "John Doe",
                                order_reference: `WEB_ORDER_${Math.floor(Math.random() * 10000)}`,
                            },
                            partial_payment: false,
                            payment_capture: 0,
                        }),
                    }
                );

                if (!orderResponse.ok) throw new Error("❌ Failed to create Razorpay order");
                const orderData = await orderResponse.json();
                console.log("🆔 Razorpay Order Created:", orderData);

                // ✅ Step 2: Open Razorpay Checkout
                const options = {
                    key: "rzp_live_RU5whSMu9rPV7s", // use live key in prod
                    amount: amountInPaise,
                    currency: "INR",
                    order_id: orderData.id || orderData.orderId,
                    name: "Maamaa's House",
                    description: "Order Payment",
                    prefill: {
                        name: "John Doe",
                        email: "john@example.com",
                        contact: "9876543210",
                    },
                    theme: { color: "#3399cc" },
                    handler: async function (response) {
                        try {
                            console.log("✅ Payment Success Response:", response);

                            // ✅ Step 3: Capture Payment
                            const captureRes = await fetch(
                                " https://backend.maamaas.com/food/api/payments/capture",
                                {
                                    method: "POST",
                                    headers: { "Content-Type": "application/json" },
                                    body: JSON.stringify({
                                        paymentId: response.razorpay_payment_id,
                                        amount: amountInPaise,
                                        currency: "INR",
                                        orderId: orderData.id || orderData.orderId,
                                    }),
                                }
                            );

                            const rawText = await captureRes.text();
                            console.log("💾 Capture API Response:", rawText);

                            if (!captureRes.ok) throw new Error("❌ Payment capture failed");

                            // ✅ Step 4: Place Order in Backend
                            const responseOrder = await axios.post(
                                ` https://backend.maamaas.com/food/api/orders/orders/create/${cartId}`,
                                null,
                                {
                                    params: {
                                        userId: userId,
                                        cartId: cartId,
                                        paymentMethod: "Online_Payment",
                                        walletType: null,
                                        razorpayPaymentId: response.razorpay_payment_id,
                                        razorpayOrderId: response.razorpay_order_id,
                                    },
                                }
                            );

                            if (responseOrder.status === 200 || responseOrder.status === 201) {
                                const newOrderId = responseOrder.data.orderId;
                                localStorage.setItem("orderId", newOrderId);
                                setOrderId(newOrderId);
                                setShowPaymentData(true);
                                alert("✅ Payment successful and order placed!");
                            } else {
                                alert("❌ Payment captured but order creation failed!");
                            }
                        } catch (err) {
                            console.error("❌ Error after payment:", err);
                            alert("❌ Payment succeeded but order failed.");
                        }
                    },
                };

                const paymentObject = new window.Razorpay(options);
                paymentObject.open();
            }
        } catch (err) {
            console.error("❌ Razorpay flow error:", err);
            alert("❌ Payment failed.");
        }
    };

    if (paymentMethod === "Online_Payment") {
        // Razorpay flow
    }

    return (
        <div style={styles.container}>
            {/* Column 2 - Sidebar */}
            {/* <div style={styles.col2}>
                <div style={styles.profileBox}>
                    <img
                        src="https://via.placeholder.com/100"
                        alt="Profile"
                        style={styles.circleImage}
                    />
                    <h3>Welcome User</h3>
                </div>
            </div> */}

            {/* Column 7 - Cart Details */}
            <div style={styles.col7}>
                <h2 style={styles.heading}>Review Order</h2>

                {/* Cart Table */}
                <div style={styles.tableContainer}>
                    <table style={styles.table}>

                        <thead>
                            <tr>
                                <th>Sr.No</th>
                                <th>Category</th>
                                <th>Type</th>
                                <th>Item</th>

                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cartItems.map((item, index) => (
                                <tr key={item.id}>
                                    <td>{index + 1}</td>
                                    <td>{item.category}</td>
                                    <td>{item.type}</td>
                                    <td>{item.name}</td>

                                    <td>
                                        <button
                                            style={styles.removeBtn}
                                            onClick={() => removeItem(item.id)}
                                        >
                                            Remove
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Billing Summary */}

                <div style={styles.summaryBox}> <h3> Billing Summary</h3> {/* Top Plates Box */} <div style={styles.platesBox}> <div style={styles.plateRow}> <span>Veg Plates:</span> <input type="number" min="0" value={vegPlates} onChange={(e) => setVegPlates(Number(e.target.value))} style={styles.input} /> <span>× ₹{priceVeg} = ₹{vegTotal}</span> </div> <div style={styles.plateRow}> <span>Non-Veg Plates:</span> <input type="number" min="0" value={nonVegPlates} onChange={(e) => setNonVegPlates(Number(e.target.value))} style={styles.input} /> <span>× ₹{priceNonVeg} = ₹{nonVegTotal}</span> </div> <div style={styles.plateRow}> <span>Mixed Plates:</span> <input type="number" min="0" value={mixedPlates} onChange={(e) => setMixedPlates(Number(e.target.value))} style={styles.input} /> <span>× ₹{priceMixed} = ₹{mixedTotal}</span> </div> </div> {/* Charges Box */} <div style={styles.chargesBox}> <div style={styles.chargeItem}> <span>Delivery Charge:</span> <span>₹{deliveryCharge}</span> </div> <div style={styles.chargeItem}> <span>Platform Charge:</span> <span>₹{platformCharge}</span> </div> <div style={styles.chargeItem}> <span>Discount ({discountPercent}%):</span> <span>-₹{discount.toFixed(2)}</span> </div> <div style={styles.chargeItem}> <span>SGST ({sgstPercent}%):</span> <span>₹{sgst.toFixed(2)}</span> </div> <div style={styles.chargeItem}> <span>CGST ({cgstPercent}%):</span> <span>₹{cgst.toFixed(2)}</span> </div> <div style={{ ...styles.chargeItem, ...styles.grandTotal }}> <span>Grand Total:</span> <span>₹{grandTotal.toFixed(2)}</span> </div>
                </div>
                </div>


                {/* Buttons */}
                <div style={{ padding: "20px" }}>
                    {/* Always show buttons */}
                    <div style={{ marginBottom: "20px", display: "flex", gap: "10px", justifyContent: 'center' }}>
                        <button
                            onClick={() => {
                                setPaymentMode("partial");
                                setPaymentMethod("");
                                setWalletType("");
                            }}
                            style={{
                                padding: "10px 20px",
                                background: paymentMode === "partial" ? "#21ba45" : "#b36dd4ff",
                                color: paymentMode === "partial" ? "#fff" : "white",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                            }}
                        >
                            Partial Payment
                        </button>
                        <button
                            onClick={() => {
                                setPaymentMode("full");
                                setPaymentMethod("");
                                setWalletType("");
                            }}
                            style={{
                                padding: "10px 20px",
                                background: paymentMode === "full" ? "#21ba45" : "#b36dd4ff",
                                color: paymentMode === "full" ? "#fff" : "white",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                            }}
                        >
                            Full Payment
                        </button>
                    </div>

                    {/* Payment Section - only when selected */}
                    {paymentMode && (
                        <div style={{ border: "1px solid #ccc", padding: "20px", borderRadius: "8px" }}>
                            {/* <h3>{paymentMode === "partial" ? "Partial Payment" : "Full Payment"}</h3> */}
                            <p>
                                Amount:{" "}
                                <strong>
                                    ₹{paymentMode === "partial" ? advancePayment.toFixed(2) : grandTotal.toFixed(2)}
                                </strong>

                                {/* Show 40% and 60% split */}
                                {paymentMode === "partial" && (
                                    <span style={{ marginLeft: "15px", fontSize: "14px", color: "black",fontWeight:"bold" }}>
                                        (40%: Mandatory| 60% Due Amount: ₹{(grandTotal - advancePayment).toFixed(2)})
                                    </span>
                                )}
                            </p>


                            {/* Payment Methods */}
                            <div style={{ marginTop: "15px" }}>
                                {/* <h4>Select Payment Method:</h4> */}
                                <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                                    <button
                                        onClick={() => {
                                            setPaymentMethod("Online_Payment");  // ✅ must match backend & checkout logic
                                            setWalletType("");
                                            handleCheckoutClickS(); // ✅ trigger checkout
                                        }}
                                        style={{
                                            padding: "8px 16px",
                                            background: paymentMethod === "Online_Payment" ? "#21ba45" : "#d972f0ff",
                                            color: paymentMethod === "Online_Payment" ? "#fff" : "#fff",
                                            border: "none",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Online
                                    </button>

                                    <button
                                        onClick={() => {
                                            setPaymentMethod("cash");
                                            setWalletType("");
                                            handlePay();
                                        }}
                                        style={{
                                            padding: "8px 16px",
                                            background: paymentMethod === "cash" ? "#21ba45" : "#d972f0ff",
                                            color: paymentMethod === "cash" ? "#fff" : "#fff",
                                            border: "none",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Cash
                                    </button>
                                    <button
                                        onClick={() => {
                                            setPaymentMethod("wallet");
                                            setWalletType("");
                                        }}
                                        style={{
                                            padding: "8px 16px",
                                            background: paymentMethod === "wallet" ? "#21ba45" : "#d972f0ff",
                                            color: paymentMethod === "wallet" ? "#fff" : "#fff",
                                            border: "none",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Wallet
                                    </button>
                                </div>
                            </div>

                            {/* Wallet dropdown */}
                            {paymentMethod === "wallet" && (
                                <div style={{ marginTop: "15px" }}>
                                    <label>
                                        Wallet Type:{" "}
                                        <select
                                            value={walletType}
                                            onChange={(e) => setWalletType(e.target.value)}
                                            style={{ padding: "6px", marginLeft: "10px" }}
                                        >
                                            <option value="">-- Select --</option>
                                            <option value="company">Company Credit</option>
                                            <option value="self">Self Credit</option>
                                        </select>
                                    </label>
                                    <button
                                        onClick={handlePay}
                                        style={{
                                            marginLeft: "15px",
                                            padding: "8px 16px",
                                            background: "#21ba45",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Pay Now
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>


        </div>
    );
};

// Styles
const styles = {
    container: {
        gap: "20px",
        // marginTop: "116px",
        // padding: "20px",
        // backgroundColor: "#f5f5f5",
        minHeight: "calc(100vh - 116px)",
        maxWidth: "1017px",
        boxSizing: "border-box",
        marginLeft: "auto",   // ✅ Left se auto
        marginRight: "auto",  // ✅ Right se auto
    },

    col2: {
        background: "#f1f1f1",
        padding: "15px",
        borderRadius: "10px",
        textAlign: "center",
        position: "sticky",
        top: "136px",
        height: "fit-content",
        alignSelf: "start",
    },
    profileBox: {
        background: "#fff",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        marginBottom: "15px",
    },
    circleImage: {
        width: "100px",
        height: "100px",
        borderRadius: "50%",
        marginBottom: "10px",
    },
    col7: {
        background: "#fff",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    },
    heading: {
        marginBottom: "15px",
        textAlign: "center",
        color: "#333",
    },
    tableContainer: {
        overflowX: "auto",
        marginBottom: "20px",

    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        borderBottom: "1px solid #eee",
    },
    tableHead: {
        background: "#f5f5f5",
    },
    removeBtn: {
        padding: "6px 10px",
        background: "#ff4757",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        fontSize: "12px",
    },
    summaryBox: {
        background: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        marginTop: "20px",
    },

    platesBox: {
        background: "#f9f9f9",
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "15px",
        marginBottom: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
    },

    plateRow: {
        display: "grid",
        gridTemplateColumns: "1fr auto auto",
        alignItems: "center",
        gap: "10px",
        paddingBottom: "8px",
        borderBottom: "1px solid #eee",
    },

    input: {
        width: "80px",
        padding: "6px",
        textAlign: "center",
        border: "1px solid #ccc",
        borderRadius: "6px",
    },

    chargesBox: {
        display: "flex",
        flexDirection: "column",
        gap: "12px",
    },

    chargeItem: {
        display: "flex",
        justifyContent: "space-between",
        borderBottom: "1px solid #eee",
        paddingBottom: "6px",
    },

    grandTotal: {
        fontWeight: "bold",
        fontSize: "18px",
        borderTop: "2px solid #000",
        paddingTop: "10px",
        marginTop: "10px",
    },

    rightBox: {
        display: "flex",
        flexDirection: "column",
        gap: "12px",
    },
    chargeItem: {
        display: "flex",
        justifyContent: "space-between",
        borderBottom: "1px solid #eee",
        paddingBottom: "6px",
    },
    grandTotal: {
        fontWeight: "bold",
        fontSize: "18px",
        borderTop: "2px solid #000",
        paddingTop: "8px",
    },
    input: {
        width: "60px",
        padding: "5px",
        textAlign: "center",
        border: "1px solid #ddd",
        borderRadius: "4px",
    },
    bookNowBtnContainer: {
        textAlign: "center",
        marginTop: "20px",
    },
    bookNowBtn: {
        padding: "12px 30px",
        background: "#ee6521",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        fontSize: "16px",
        fontWeight: "bold",
        marginRight: "15px",  // ✅ next button ke bich space
    },

    fullBtn: {
        padding: "12px 30px",
        background: "#ee6521",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        fontSize: "16px",
        fontWeight: "bold",
    },

    paymentSection: {
        padding: "20px",
        background: "#ee6521",
        borderRadius: "10px",
        marginTop: "20px",
    },
    methodOptions: {
        display: "flex",
        gap: "10px",
        marginTop: "10px",
    },

    methodBtn: {
        padding: "8px 18px",
        border: "1px solid #ccc",
        borderRadius: "5px",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: "500",
        backgroundColor: "#f0f0f0",
        transition: "all 0.3s ease",
    },

    methodLabel: {
        display: "flex",
        alignItems: "center",
        gap: "5px",
        cursor: "pointer",
    },
    paymentOptions: {
        display: "flex",
        flexDirection: "column",
        gap: "15px",
    },
    paymentItem: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "15px",
        background: "#fff",
        marginTop: '20px',
        borderRadius: "8px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    },
    payBtn: {
        padding: "8px 16px",
        background: "#007bff",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        minWidth: "100px",
    },
    fullPayBtn: {
        padding: "8px 16px",
        background: "#28a745",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        minWidth: "100px",
    },
    col3: {
        background: "#fdf3f3",
        padding: "15px",
        borderRadius: "10px",
        textAlign: "center",
        position: "sticky",
        top: "136px",
        height: "fit-content",
        alignSelf: "start",
    },
    adBox: {
        height: "300px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
    },
    // Media queries for responsiveness
    "@media (max-width: 1200px)": {
        container: {
            gridTemplateColumns: "1fr 2fr",
        },
        col3: {
            display: "none",
        },
    },
    "@media (max-width: 768px)": {
        container: {
            gridTemplateColumns: "1fr",
            marginTop: "90px",
            padding: "10px",
        },
        col2: {
            position: "relative",
            top: "0",
        },
        col7: {
            padding: "15px",
        },
        summaryGrid: {
            gridTemplateColumns: "1fr",
        },
        grandTotal: {
            gridColumn: "1",
        },
        paymentItem: {
            flexDirection: "column",
            gap: "10px",
            textAlign: "center",
        },
        methodOptions: {
            flexDirection: "column",
            alignItems: "flex-start",
        },


    },
};

// Add responsive styles
const responsiveStyles = {
    ...styles,
    container: {
        ...styles.container,
        [`@media (max-width: ${1200}px)`]: {
            gridTemplateColumns: "1fr 2fr",
        },
        [`@media (max-width: ${768}px)`]: {
            gridTemplateColumns: "1fr",
            marginTop: "90px",
            padding: "10px",
        },
    },
    col2: {
        ...styles.col2,
        [`@media (max-width: ${768}px)`]: {
            position: "relative",
            top: "0",
        },
    },
    col3: {
        ...styles.col3,
        [`@media (max-width: ${1200}px)`]: {
            display: "none",
        },
    },
    summaryGrid: {
        ...styles.summaryGrid,
        [`@media (max-width: ${768}px)`]: {
            gridTemplateColumns: "1fr",
        },
    },
    grandTotal: {
        ...styles.grandTotal,
        [`@media (max-width: ${768}px)`]: {
            gridColumn: "1",
        },
    },
    paymentItem: {
        ...styles.paymentItem,
        [`@media (max-width: ${768}px)`]: {
            flexDirection: "column",
            gap: "10px",
            textAlign: "center",
        },
    },
    methodOptions: {
        ...styles.methodOptions,
        [`@media (max-width: ${768}px)`]: {
            flexDirection: "column",
            alignItems: "flex-start",
        },
    },
};

// Apply responsive styles
Object.assign(styles, responsiveStyles);

export default CartPage;

